import { render, staticRenderFns } from "./ClientInfoActivates.vue?vue&type=template&id=19e079e1&scoped=true"
import script from "./ClientInfoActivates.vue?vue&type=script&lang=js"
export * from "./ClientInfoActivates.vue?vue&type=script&lang=js"
import style0 from "./ClientInfoActivates.vue?vue&type=style&index=0&id=19e079e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e079e1",
  null
  
)

export default component.exports